import React, { useState, useEffect } from 'react';
import OfficeInfo from './components/OfficeInfo';
import ServiceList from './components/ServiceList';
import FullScreenMessage from "./components/FullScreenMessage";
import './App.css';
import { cqAPI, HOST, getBid } from "./lib/Auth";
import { useLocation } from "react-router-dom";
import { trackPageView, initializeGA, setProperties } from "./lib/GA";

const App = () => {
  const [officeData, setOfficeData] = useState({ services: [], business: {} });
  const [hasError, setHasError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const [isGAInitialized, setIsGAInitialized] = useState(false)
  
  useEffect(() => {
    const bid = getBid();
    if (bid){
      const script = document.createElement('script');
      script.src = `${HOST}/widget.js?bid=${bid}`;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);
  
  useEffect(() => {
    cqAPI.get('/services')
      .then(data => {
        if (data.type === 'ok') {
          setOfficeData(data.data);
          initializeGA(data.data.business.ga4);
          const bid = getBid();
          if (bid){
            setProperties({ bid });
          }
          setIsGAInitialized(true)
        } else {
          if (data.code) {
            setHasError(true);
          }
        }
        setIsLoading(false)
      })
      .catch(error => {
        setHasError(true);
        setIsLoading(false)
      });
  }, []);
  
  useEffect(() => {
    if (!isGAInitialized){return}
    trackPageView(location.pathname + location.search);
  }, [location, isGAInitialized]);
  
  if (hasError) {
    return <FullScreenMessage message="This is not a valid link" />;
  }
  
  if (isLoading) {
    return (
      <div className="spinner-container">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <div className="app-container">
      <div className="header">Choose a service</div>
      <OfficeInfo info={officeData.business} />
      <ServiceList services={officeData.services} onSelectService={(serviceId) => console.log(serviceId)} />
    </div>
  );
};

export default App;
